import { useContext } from "react";

import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";
import { useDeliveryEndpointsData } from "./useDeliveryEndpointsData";

export const useDeliveryInfo = () => {
    const { getDeliveryEndpoint } = useDeliveryEndpointsData();

    const { systemPlatformDetailsItem } = useContext(SystemPlatformDetailsContext);

    const deliveryEndpoint = systemPlatformDetailsItem.deliveryInfo.deliveryEndpoint
        ? getDeliveryEndpoint(systemPlatformDetailsItem.deliveryInfo.deliveryEndpoint.id)
        : undefined;

    const distributionList = systemPlatformDetailsItem.deliveryInfo?.distributionList;

    return { deliveryEndpoint, distributionList };
};
